module.exports = __webpack_public_path__ + "img/courses_empty03.214f2db.png";